import { getLoaders } from 'entities/_config';

import { apiCall } from 'services/api';

export const wppLoaders = getLoaders({
  canConfirm: {
    load: async (): Promise<{ enabled: boolean; rewardPoints: number }> => {
      return apiCall({
        path: '/whatsapp/confirmation-status',
        method: 'get',
      });
    },
  },
});
